<template>
  <mdb-container>
    <mdb-col v-if="showSpinner">
      <Spinner />
    </mdb-col>
    <mdb-row>
      <AssetForm @asset-created="onAssetCreated" />
    </mdb-row>

    <mdb-row>
      <AssetList :assets="assets" />
    </mdb-row>
  </mdb-container>
</template>

<script>
import api from "@/api";
import Spinner from "@/components/Spinner";
import AssetForm from "@/components/AssetForm";
import AssetList from "@/components/AssetList";
import { mdbRow, mdbCol, mdbContainer } from "mdbvue";

export default {
  name: "AssetsConfig",
  components: {
    mdbRow,
    mdbCol,
    mdbContainer,
    Spinner,
    AssetForm,
    AssetList,
  },
  data() {
    return {
      assets: [],
      isLoading: true,
    };
  },

  computed: {
    showSpinner() {
      return this.isLoading;
    },
  },
  created() {
    this.isLoading = false;
    this.getAssetList();
    this.isLoading = false;
  },
  methods: {
    onAssetCreated() {
      this.getAssetList();
    },

    getAssetList() {
      api
        .getScannableAssets()
        .then((response) => {
          this.assets.splice(0, this.assets.length, ...response.data);
          this.isLoading = false;
        })
        .catch((e) => {
          console.error(e);
        });
    },
  },
};
</script>

<style scoped lang="scss"></style>
